<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox :pageName="$t('product.text0')"></navBox>
			<!--导航-->
			<!--banner-->
			<div v-if="bannerList" class="banner_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<van-swipe class="swipe_box" :autoplay="5000" :show-indicators="false" :stop-propagation="false" @change="bannerChange">
					<van-swipe-item v-for="(value, index) in bannerList" :key="index">
						<div class="swiper_el">
							<img class="bg" :src="value.imgUrl" @dragstart.prevent />
							<div class="msg_box">
								<div class="tit_b">{{ $t('product.text1') }}</div>
								<div class="tit">{{ $t('product.text2') }}</div>
								<!-- <div class="tips">
									全部产品&nbsp;<van-icon name="arrow" size="16px" color="#000000" style="position: relative;top: 3px;" />
								</div> -->
							</div>
						</div>
					</van-swipe-item>
				</van-swipe>
				<div v-if="bannerList.length > 1" class="indicators_box">
					<div v-for="(value, index) in bannerList" :key="index" class="indicators_el" :class="bannerIndex == index ? 'actived' : ''"></div>
				</div>
			</div>
			<!--banner-->
			<!--位置块-->
			<div class="location_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="location_main">
					<van-icon name="wap-home-o" size="20px" color="#000000" style="position: relative;top: 4px;" />&nbsp;
					<span style="cursor: pointer;" @click="goHome">{{ $t('product.text4') }}</span>&ensp;
					<van-icon name="arrow" size="20px" color="#000000" style="position: relative;top: 4px;" />&ensp;
					<span class="actived">{{ $t('product.text5') }}</span>
				</div>
			</div>
			<!--位置块-->
			<!--块1-->
			<div ref="myElement" class="block_1">
				<div class="block_1_top"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="left">
						<span @click="filterShow = true;">
							{{ $t('product.text7') }}
							<van-icon name="arrow-down" size="18px" style="top: 2px;" />
						</span>&ensp;&ensp;&ensp;
						<span @click="reloadList">{{ $t('product.text8') }}</span>
					</div>
					<div class="right">
						<van-icon name="search" size="20px" style="top: 4px;" />
						<input v-model="inputVal" :placeholder="$t('product.text9')" @keyup.enter="searchClick" />
						<div class="tit" @click="searchClick">{{ $t('product.text10') }}</div>
					</div>
				</div>
				<div class="diver"></div>
				<div v-if="listData.length > 0">
					<div class="list_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div
							v-for="(value, index) in listData"
							:key="index"
							class="list_el"
							@click="goInfo(value)"
						>
							<div class="tit">{{ value.name }}</div>
							<div class="txt">{{ value.description }}</div>
							<div class="img_box">
								<img :src="webUrl + value.thumb" />
							</div>
							<div class="btn_box">
								<div class="public_btn">{{ $t('product.text6') }}<van-icon name="arrow" size="16px" class="btn_icon" /></div>
							</div>
						</div>
					</div>
					<div class="page_box">
						<el-pagination
							:small="false"
							background
							layout="prev, pager, next"
							:total="total"
							:page-size="10"
							@current-change="pageChange"
						>
						</el-pagination>
					</div>
				</div>
				<div v-else
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<van-empty image="search" description="No Data" />
				</div>
			</div>
			<!--块1-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
			<!--筛选-->
			<van-popup
				v-model="filterShow"
				round
				:close-on-click-overlay="false"
				closeable
				:style="{ width: '80%', height: '80%' }"
			>
				<div class="filter_box">
					<div class="top_box">
						<div class="title">{{ $t('product.text11') }}</div>
						<div class="top_bot">
							<div class="left"></div>
							<div class="right">
								<span @click="reloadFilter">{{ $t('product.text14') }}</span>
								<div class="btn_box" @click="filterYes">
									<div class="public_btn">{{ $t('product.text15') }}</div>
								</div>
							</div>
						</div>
					</div>
					<div class="filter_list"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="filter_el">
							<div class="title">{{ $t('nav.text3') }}</div>
							<div class="filter_el_el">
								<div v-for="(value, index) in cert_list" :key="index" class="product_el" :class="value.is_checked == 1 ? 'avtived' : ''" @click="filterClick(value)">{{ value.title }}</div>
							</div>
						</div>
						<div class="filter_el">
							<div class="title">{{ $t('nav.text2') }}</div>
							<div class="filter_el_el">
								<div v-for="(value, index) in cate_list" :key="index" class="product_el" :class="value.is_checked == 1 ? 'avtived' : ''" @click="filterClick(value)">{{ value.title }}</div>
							</div>
						</div>
					</div>
				</div>
			</van-popup>
			<!--筛选-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import { UPURL } from '@/util/util';
import { productSelectList, productList } from '@/api/public'
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			bannerList: [
				{ imgUrl: require('@/assets/img_public/products/banner01.webp') }
			],
			bannerIndex: 0,  //当前轮播索引
			filterShow: false,  //筛选弹框
			checked: false,
			listData: [],
			page: 1,
			total: 0,
			webUrl: UPURL,
			inputVal: '',
			scenarios_list: [],  //应用场景
			cate_list: [],  //产品分类
			cert_list: [],  //产品认证
			scenariosIds: '',
			cateIds: '',
			certIds: '',
			lang: sessionStorage.getItem('lang'),
		}
	},
	created(){
		let that = this;
		if(that.$route.query.scenarios_ids) {
			that.scenariosIds = that.$route.query.scenarios_ids;
		}
		if(that.$route.query.cate_ids) {
			that.cateIds = that.$route.query.cate_ids;
		}
		if(that.$route.query.cert_ids) {
			that.certIds = that.$route.query.cert_ids;
		}
		//请求产品数据
		that.getList();
		//请求产品分类
		that.getProductSelectList();
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//点击首页
		goHome() {
			this.$router.push({ path: '/' });
		},
		//筛选项点击
		filterClick(value) {
			let that = this;
			value.is_checked = !value.is_checked;
		},
		//清除条件
		reloadFilter() {
			let that = this;
			that.scenariosIds = '';
			that.cateIds = '';
			that.certIds = '';
			that.getProductSelectList();
		},
		//重置筛选
		reloadList() {
			let that = this;
			that.page = 1;
			that.scenariosIds = '';
			that.cateIds = '';
			that.certIds = '';
			that.getProductSelectList();
			that.getList();
		},
		//产品分类
		getProductSelectList() {
			let that = this;
			that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
			productSelectList({
				scenarios_ids: that.scenariosIds,
				cate_ids: that.cateIds,
				cert_ids: that.certIds,
				language: that.lang,
			}).then(res => {
				that.scenarios_list = res.data.scenarios_list;
				that.cate_list = res.data.cate_list;
				that.cert_list = res.data.cert_list;
				that.$toast.clear();
			});
		},
		initArray(data) {
			let ids = [];
			data.forEach((value1, index1) => {
				if(value1.is_checked) { ids.push(value1.id); } 
				if(value1.children.length > 0) {
					value1.children.forEach((value2, index2) => {
						if(value2.is_checked) { ids.push(value2.id); } 
						if(value2.children.length > 0) {
							value2.children.forEach((value3, index3) => {
								if(value3.is_checked) { ids.push(value3.id); } 
							});
						}
					});
				}
			});
			return ids.join(',');
		},
		//筛选确定
		filterYes() {
			let that = this;
			that.scenariosIds = that.initArray(that.scenarios_list);
			that.cateIds = that.initArray(that.cate_list);
			that.certIds = that.initArray(that.cert_list);
			// console.log(that.scenariosIds);
			// console.log(that.cateIds);
			// console.log(that.certIds);
			that.filterShow = false;
			that.page = 1;
			that.getList();
		},
		//点击搜索
		searchClick() {
			let that = this;
			that.page = 1;
			that.getList();
		},
		//分页点击
		pageChange(val) {
			let that = this;
			that.page = val;
			that.getList(true);
		},
		//获取列表
		getList(type) {
			let that = this;
			that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
			productList({
				keyword: that.inputVal,
				cate_id: that.cateIds,
				scenarios_id: that.scenariosIds,
				cert_id: that.certIds,
				page: that.page,
				page_size: 10,
				language: sessionStorage.getItem('lang')
			}).then(res => {
				that.listData = res.data.data;
				that.total = res.data.total;
				that.listLoading = false;
				that.$toast.clear();
				if(type) {
					//滚动到列表顶部
					that.$refs.myElement.scrollIntoView({ behavior: 'smooth' });
				}
			});
		},
		//点击查看详情
		goInfo(value) {
			let that = this;
			let routeData = that.$router.resolve({name: "ProductInfo", params: { productInfoId: value.id + '.html' } });
			window.open(routeData.href, '_blank');
		},
		//banner变化
		bannerChange(index) {
			let that = this;
			that.bannerIndex = index;
		},
	}
}
</script>
<style lang="less" scoped>
.main_box{
	//筛选弹框
	.filter_box{
		padding: 50px 60px;
		.filter_list{
			padding-top: 40px;
			.filter_el{
				padding-bottom: 30px;
				.filter_el_el{
					.product_el{
						display: inline-block;
						margin: 0 20px 20px 0;
						padding: 8px 14px;
						font-size: 18px;
						background-color: #F7F6F9;
						border-radius: 8px;
						cursor: pointer;
						user-select: none;
					}
					.product_el:hover{
						color: #A50073;
					}
					.product_el.avtived{
						color: #ffffff;
						background-color: #A50073;
					}
				}
				.title{
					font-size: 22px;
					font-weight: bold;
					margin-bottom: 40px;
					border-left: 2px solid #A50073;
					line-height: 1;
					padding-top: 2px;
					padding-left: 12px;
				}
			}
		}
		.top_box{
			padding-bottom: 20px;
			border-bottom: 1px solid #ECE7E8;
			.top_bot{
				display: flex;
				align-items: center;
				padding-top: 30px;
				.right{
					width: auto;
					span{
						display: inline-block;
						margin-right: 30px;
						cursor: pointer;
						user-select: none;
					}
					.btn_box{
						display: inline-block;
						.public_btn{
							padding-bottom: 5px;
							padding-left: 18px;
						}
					}
				}
				.left{
					flex: 1;
					div{
						display: inline-block;
						margin-right: 30px;
						font-size: 20px;
						cursor: pointer;
					}
					div.actived{
						color: #A20073;
						font-weight: bold;
					}
					div:last-child{
						margin-right: 0;
					}
				}
			}
			.title{
				font-size: 32px;
			}
		}
	}
	//块1
	.block_1{
		background: url(../../assets/img_public/products/block03.webp) no-repeat 100% 100%;
		background-size: cover;
		.page_box{
			padding-bottom: 100px;
			text-align: center;
		}
		.list_box{
			width: 1520px;
			margin: 0 auto;
			padding: 80px 0 80px 0;
			.list_el{
				display: inline-block;
				position: relative;
				width: 48%;
				margin: 1%;
				padding: 40px;
				background-color: #ffffff;
				border-radius: 8px;
				cursor: pointer;
				.btn_box{
					position: absolute;
					right: 40px;
					bottom: 80px;
				}
				.img_box{
					width: 50%;
					padding-top: 20px;
					img{
						width: 100%;
						height: 216px;
						object-fit: contain;
					}
				}
				.txt{
					padding-top: 10px;
					height: 55px;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
				}
				.tit{
					font-size: 24px;
					font-weight: bold;
					height: 75px;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
				}
			}
			.list_el:hover{
				box-shadow: 0px 0px 30px 1px rgba(0,0,0,0.1);
				.tit{
					color: #A20073;
				}
			}
		}
		.diver{
			height: 10px;
			background-color: #ffffff;
		}
		.block_1_top{
			width: 1264px;
			display: flex;
			align-items: center;
			margin: 0 auto;
			padding: 40px 0;
			.right{
				width: auto;
				position: relative;
				padding: 0 30px;
				background-color: #ffffff;
				border: 1px solid #A50073;
				border-radius: 8px;
				input{
					width: 280px;
					height: 48px;
					font-size: 16px;
					color: #A50073;
					border: none;
					padding: 0px 5px;
					user-select: none;
				}
				.tit{
					display: inline-block;
					font-size: 18px;
					cursor: pointer;
					line-height: 1;
					user-select: none;
				}
			}
			.left{
				flex: 1;
				span{
					display: inline-block;
					cursor: pointer;
					font-size: 18px;
				}
			}
		}
	}
	//轮播
	.banner_box{
		min-width: 1200px;
		position: relative;
		.indicators_box{
			position: absolute;
			bottom: 50px;
			left: 50%;
			transform: translate(-50%, 0);
			.indicators_el{
				width: 100px;
				height: 2px;
				display: inline-block;
				margin: 0 5px;
				background-color: rgba(0, 0, 0, 0.3);
			}
			.actived{
				background-color: #A20073;
			}
		}
		.swipe_box{
			.swiper_el{
				position: relative;
				.msg_box{
					width: 1264px;
					margin: 0 auto 0 auto;
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
					text-align: right;
					.tips{
						margin-top: 40px;
						display: inline-block;
						font-size: 16px;
						padding: 8px 16px;
						border-radius: 8px;
						border: 1px solid #999999;
					}
					.tit{
						margin-top: 10px;
						font-size: 16px;
						color: #A50073;
					}
					.tit_b{
						font-size: 40px;
						font-weight: bold;
						color: #A50073;
					}
				}
				img.bg{
					width: 100%;
				}
			}
		}
	}
}
</style>
<style scoped>
/*筛选复选框*/
>>> .filter_box .van-checkbox__label{
	position: relative;
	top: 3px;
	font-size: 18px;
}
/*分页*/
>>> .page_box .el-pager li:hover{
	color: #A50073 !important;
}
>>> .page_box .el-pagination.is-background .el-pager li:not(.disabled).active{
	background-color: #A50073 !important;
}
>>> .page_box .el-pagination.is-background .el-pager li:not(.disabled).active:hover{
	color: #ffffff !important;
}
</style>